<template>
    <div class="rsk-flex rsk-justify-between rsk-items-center rsk-mb-s">
        <div class="rsk-font-bold rsk-font-xl">
            {{ title }}
        </div>

        <div class="describe" v-if="describe" v-dompurify-html="describe" ></div>
        <!-- <select class="rsk-input rsk-input--narrow" placeholder="Placeholder">
            <option>追加順</option>
        </select> -->
        <el-select class="rsk-select" clearable v-if="options" size="mini" v-model="selectValue" placeholder="">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>
<script>
import { ref } from 'vue';
export default {
    props: {
        title: String,
        /**
         * {
         *  label,
         *  value
         * }
         */
        describe: String,
        options: Array
    },
    setup(props) {
        let selectValue = ref('');
        return {
            selectValue,
            ...props
        }
    },
}
</script>
<style>
.rsk-select .el-input__inner {
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    border-color: #A8B0BB;
    color: #30353B;
}

.describe {
    width: 420px;
    height: 17px;
    margin-top: 6px;
    /* margin-left: -8px; */
    margin-left: auto;
    gap: 0px;
    font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", メイリオ, Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
    font-size: 11px;
    font-weight: 300;
    line-height: 17px;
    text-align: right;
    color: #676F79;
    margin-right: 8px;
}

.describe-text {
  line-height: 1.5;
}

.link-training, .link-box {
    color: #066CE5;
    text-decoration: underline;
    cursor: pointer;
    margin: 0 2px;
    font-size: inherit;
    font-weight: inherit;
    text-decoration: none;
}

.link-training:hover, .link-box:hover {
  color: #66B1FF;
  text-decoration: underline;
}
</style>
